module.exports = Object.assign